// const STORAGE_KEY = "rw_anonymous_id";
// const COOKIE_KEY = "rw_anon";

// export const getOrCreateAnonymousId = () => {
//   if (typeof window === "undefined") return null;

//   let id = localStorage.getItem(STORAGE_KEY);

//   if (!id) {
//     const match = document.cookie.match(new RegExp(`${COOKIE_KEY}=([^;]+)`));
//     if (match) id = match[1];
//   }

//   if (!id || id.length < 16) {
//     id =
//       typeof crypto !== "undefined" && crypto.randomUUID
//         ? crypto.randomUUID().replace(/-/g, "")
//         : `anon${Date.now()}${Math.random().toString(36).slice(2, 10)}`;

//     localStorage.setItem(STORAGE_KEY, id);
//     document.cookie = `${COOKIE_KEY}=${id}; max-age=${60 * 60 * 24 * 365}; path=/; SameSite=Lax`;
//   }

//   return id;
// };

const STORAGE_KEY = "rw_anonymous_id";
const COOKIE_KEY = "rw_anon";

export const getOrCreateAnonymousId = () => {
  if (typeof window === "undefined") return null;

  // 1. Pehle localStorage check karein (Sabse stable aur permanent)
  let id = localStorage.getItem(STORAGE_KEY);

  // 2. Agar localStorage me nahi hai, tabhi cookie check karein
  if (!id) {
    const match = document.cookie.match(new RegExp(`${COOKIE_KEY}=([^;]+)`));
    if (match && match[1] && match[1].length >= 16) {
      id = match[1];
      localStorage.setItem(STORAGE_KEY, id);
    }
  }

  // 3. Agar bilkul nahi hai, tab naya ID banayein
  if (!id || id.length < 16) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID().replace(/-/g, "")
        : `anon${Date.now()}${Math.random().toString(36).slice(2, 10)}`;

    localStorage.setItem(STORAGE_KEY, id);
  }

  // Cookie ko hamesha localStorage ke sath sync rakhein (1 saal validity)
  document.cookie = `${COOKIE_KEY}=${id}; max-age=${60 * 60 * 24 * 365}; path=/; SameSite=Lax`;

  return id;
};